import { isEmpty } from 'lodash'

import { OnboardingPage, OnboardingQuestionType } from 'enums/onboardingQuestion'

export const getUnansweredQuestions = (page: string, answers: any[]) => {
  let unansweredQuestions: any[] = []

  if (page === OnboardingPage.RatingAndSimpleSelect) {
    unansweredQuestions = answers.filter(
      answer =>
        (answer.type === OnboardingQuestionType.Rating &&
          !answer.satisfaction) ||
        (answer.type === OnboardingQuestionType.SimpleSelect &&
          !answer.selected_choice_id),
    )
  }

  if (page === OnboardingPage.Reward) {
    unansweredQuestions = answers.filter(
      answer =>
        answer.type === OnboardingQuestionType.Reward && !answer.satisfaction,
    )
  }

  if (page === OnboardingPage.Event) {
    answers.forEach((answer: any) => {
      if (answer.type === OnboardingQuestionType.Event) {
        if (
          answer.wants_to_be_recognized === null ||
          answer.wants_to_be_recognized === undefined ||
          answer.wants_to_be_recognized === ''
        ) {
          unansweredQuestions.push(answer)
        } else if (answer.wants_to_be_recognized === true) {
          if (
            answer.wants_to_be_recognized_in_public === null ||
            answer.wants_to_be_recognized_in_public === undefined ||
            answer.wants_to_be_recognized_in_public === ''
          ) {
            unansweredQuestions.push(answer)
          }
        }
      }
    })
  }

  if (page === OnboardingPage.ChoiceGroup) {
    unansweredQuestions = answers.filter(
      answer =>
        answer.type === OnboardingQuestionType.ChoiceGroup &&
        answer.choice_group !== null &&
        !answer.selected_choice_id,
    )
  }

  return unansweredQuestions
}

// ProfileQuestions and ProfileSettings have no per-field validation gate
// (isNextPageButtonDisabled never blocks on them), so "answered" for those
// just means the user has already moved past that step. The last page in
// `pages` has no "next" page to move past to, so it's only ever marked
// answered once onboarding has actually finished (isOnboardingComplete).
export const isPageAnswered = (
  page: string,
  pages: string[],
  pagination: string,
  answers: any[],
  isOnboardingComplete = false,
) => {
  if (
    [OnboardingPage.ProfileQuestions, OnboardingPage.ProfileSettings].includes(
      page as OnboardingPage,
    )
  ) {
    if (isOnboardingComplete && pages[pages.length - 1] === page) return true

    return pages.indexOf(pagination) > pages.indexOf(page)
  }

  return isEmpty(getUnansweredQuestions(page, answers))
}

// Saving the ProfileQuestions step must only touch the answers it owns.
// profileState is the full user record (it also backs the ProfileSettings
// step further down the flow), so sending it wholesale here would re-submit
// notification/visibility preferences the user hasn't reached yet and can
// trip validations unrelated to this step (e.g. SMS requiring a phone
// number) on every page turn, not just on Finish.
export const buildProfileAnswersPayload = (profileState: any) => ({
  id: profileState.id,
  profile_answers_attributes: profileState.profile_answers_attributes,
})
